import { getCookie } from "cookies-next";

export const getAdminToken = (): string | undefined => {
  return getCookie("accessToken") as string | undefined;
};

export const isAdminAuthenticated = (): boolean => {
  return !!getAdminToken();
};
